import React from 'react';
import HeaderThin from 'app/components/layout/HeaderThin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import base64 from 'base-64';
import { Link } from 'react-router-dom';

import PaymentRequestsTable from 'app/components/teamPaymentRequests/PaymentRequestsTable';

import * as teamPaymentRequestActions from 'app/ducks/teamPaymentRequests/actions';
import * as teamMemberActions from 'app/ducks/teamMembers/actions';
import * as teamActions from 'app/ducks/teams/actions';
import * as reminderActions from 'app/ducks/reminders/actions';

import * as teamSelectors from 'app/ducks/teams/selectors';
import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamPaymentRequestsSelectors from 'app/ducks/teamPaymentRequests/selectors';
import * as teamMemberSelectors from 'app/ducks/teamMembers/selectors';

interface IPaymentRequestsListProps {
  match?: any;
  actions?: any;
  teamPaymentRequests?: any;
  appReady?: boolean;
  teamMembers: any;
  teams: any;
}

interface IPaymentRequestsListState {
  initialFilter: any;
  error?: string;
}

function selector(state) {
  return {
    teamPaymentRequests: teamPaymentRequestsSelectors.getTeamPaymentRequests(state),
    teamMembers: teamMemberSelectors.getTeamMembers(state),
    teams: teamSelectors.getTeams(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  teamPaymentRequestActions,
  teamActions,
  teamMemberActions,
  reminderActions,
);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class PaymentRequestsList extends React.Component<IPaymentRequestsListProps, IPaymentRequestsListState> {
  static defaultProps: IPaymentRequestsListProps = {
    actions: undefined,
    teamPaymentRequests: undefined,
    teamMembers: undefined,
    teams: undefined,
    appReady: false,
    match: false,
  };

  // componentDidMount(): void {
  //   this.props.actions.getAllTeamPaymentRequests();
  // }

  render(): React.ReactNode {
    const filterConfig = this.props.match?.params?.filterConfig ? JSON.parse(base64.decode(this.props.match?.params?.filterConfig)) : undefined;

    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Payment Requests"
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <PaymentRequestsTable
              teamPaymentRequestsById={this.props.teamPaymentRequests.teamPaymentRequestsById}
              teamPaymentRequestIds={this.props.teamPaymentRequests.teamPaymentRequestIds}
              pagination={this.props.teamPaymentRequests.pagination}
              appReady={this.props.appReady}
              actions={this.props.actions}
              saveFilters
              initialFilterConfig={filterConfig}
              isLoading={this.props.teamPaymentRequests.isLoading}
              selectTeamPaymentRequest={this.props.actions.selectTeamPaymentRequest}
              createReminder={this.props.actions.createReminder}
            />
            {/* {this.props.teamMembers.teamMemberIds?.length === 0 && (
              <div className="row with-margin-top-10">
                <div className="col text-center">
                  Go to
                  {' '}
                  <Link to="/manage-team">Manage Team</Link>
                  {' '}
                  to add team
                  members.
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>
    );
  }
}
